module.exports = __webpack_public_path__ + "static/media/Focused.e6ad7a3f.svg";